var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cd2a30;\n      }\n\n      .cls-2 {\n        fill: #308e44;\n      }\n\n      .cls-3 {\n        fill: #00579d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m24.12,35.29c-1.23,1.21,7.16-15.79,7.16-15.79l35.05,60.55-22.28.45s-3.99-1.73-5.87-5.63c-.77-1.59-.35-3.89-.48-6.03.54-3.74-3.68-7.97-3.68-7.97,0,0-2.51-1.7-3.75-2.31,2.43-4.28-.71-7.96-.71-7.96,1.21-2.83.96-6.99-.36-9.62-1.77-3.5-5.08-5.68-5.08-5.68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.63,59.62l-8.96,20.58,37.44.14s-3.55-2.74-4.47-5.3c.06-2.57-.64-7.71-.64-7.71,0,0-1.43-5.65-6.84-7.31-5.57,4.54-10.2-.39-10.04-.39s-6.49-.01-6.49-.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.51,55.15c0-3.13,2.6-5.68,5.81-5.68s5.8,2.54,5.8,5.68-2.6,5.68-5.8,5.68-5.81-2.54-5.81-5.68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.54,46.63c0-6.75,5.59-12.21,12.49-12.21s12.49,5.47,12.49,12.21c0,1.33-.21,2.61-.62,3.81-1.19-1.23-2.89-2-4.78-2-3.59,0-6.5,2.77-6.5,6.19,0,1.54.15,3.12,1.13,4.2-.7.12-.98.01-1.72.01-6.9,0-12.49-5.47-12.49-12.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue07);
export default __webpack_public_path__ + "static/media/blue07.80311c27838a32a8908905d5133eb6a5.svg";
export { ForwardRef as ReactComponent };